import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import RoomReportDetails from '../components/report/RoomReportDetails';

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ roomReportDetails, loading, intl, dispatch }) => {
    return (
      <div className="container-left">
        <RoomReportDetails
          intl={intl}
          dispatch={dispatch}
          loading={loading}
          roomReportDetails={roomReportDetails}
        />
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/roomReportDetails.js